import * as React from 'react';
import type { DisplayLayoutModeType } from '@sdk/schedule/types/DisplayLayoutModeType';

import type { ScheduleContextType } from './hooks/useScheduleCtxBuilder';
import type { FormattedDateString } from './types/FormattedDateString';
import type { EventCollectionType } from './types';
import useScheduleCtxBuilder from './hooks/useScheduleCtxBuilder';

const ScheduleContext = React.createContext<ScheduleContextType>({
  allEventsDict: null,
  allUsers: null,
  personasDict: null,
  displayMode: 'week',
  currentPeriodDays: [],
});

type Props = {
  eventCollection: EventCollectionType;
  personaCollection: {
    personasDict: {
      [key in string]: any;
    };
  };
  displayMode: DisplayLayoutModeType;
  currentPeriodDays: FormattedDateString[];
};
const ScheduleProvider: React.FC<React.PropsWithChildren<Props>> = ({
  children,
  eventCollection,
  personaCollection,
  displayMode,
  currentPeriodDays,
}) => {
  const scheduleCtx = useScheduleCtxBuilder({
    eventCollection,
    personaCollection,
    displayMode,
    currentPeriodDays,
  });

  return <ScheduleContext.Provider value={scheduleCtx}>{children}</ScheduleContext.Provider>;
};

export { ScheduleContext, ScheduleProvider };
